export type MiddlewareFunc<T> = (
  context: T,
  next: () => void,
) => Promise<void> | void;

export class Middleware<T> {
  private middleware_: MiddlewareFunc<T>[] = [];

  use(...middlware: MiddlewareFunc<T>[]) {
    this.middleware_.push(...middlware);
  }

  async apply(context: T) {
    let next = false;

    for (let i = this.middleware_.length - 1; i >= 0; --i) {
      next = false;

      // eslint-disable-next-line
      await this.middleware_[i](context, () => {
        next = true;
      });

      if (!next) break;
    }

    return context;
  }
}
